import OlvCampaignParams from './OlvCampaignParams';

export default OlvCampaignParams;
export * from './OlvCampaignParams';
